import React, { useEffect, useState, createElement } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, Phone, Clock, Zap, Shield, Lock, ChevronDown, ChevronUp, User, DollarSign, Users, Activity, PhoneCall, IdCard, Volume2, HelpCircle, BadgeCheck, ShieldCheck, FileCheck } from 'lucide-react';
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-96">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-3 text-left bg-white hover:bg-gray-50 transition-colors" data-id="element-97">
        <span className="font-medium text-dark text-xs sm:text-sm" data-id="element-98">
          {question}
        </span>
        {isOpen ? <ChevronUp className="w-4 h-4 text-gray-400 flex-shrink-0 ml-2" data-id="element-99" /> : <ChevronDown className="w-4 h-4 text-gray-400 flex-shrink-0 ml-2" data-id="element-100" />}
      </button>
      {isOpen && <div className="px-3 pb-3 text-gray-600 text-xs bg-white" data-id="element-101">{answer}</div>}
    </div>;
}
export function SuccessPage() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://widgets.leadconnectorhq.com/loader.js';
    script.setAttribute('data-resources-url', 'https://widgets.leadconnectorhq.com/chat-widget/loader.js');
    script.setAttribute('data-widget-id', '69e1236d5d1f0e7d13a4c53d');
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <div className="w-full max-w-2xl mx-auto px-4 py-1 sm:py-6 space-y-3 sm:space-y-5" data-id="element-102">
      {/* Hero */}
      <div className="text-center" data-id="element-103">
        <motion.div initial={{
        scale: 0
      }} animate={{
        scale: 1
      }} transition={{
        type: 'spring',
        stiffness: 200,
        damping: 15
      }} className="inline-flex items-center justify-center w-12 h-12 sm:w-16 sm:h-16 bg-green-100 rounded-full mb-2" data-id="element-104">
          <CheckCircle className="w-6 h-6 sm:w-8 sm:h-8 text-green-600" data-id="element-105" />
        </motion.div>
        <h1 className="text-lg sm:text-2xl font-bold text-dark mb-0.5" data-id="element-106">
          ¡Felicidades! Tu Solicitud Fue Recibida
        </h1>
        <p className="text-gray-500 text-xs sm:text-sm font-medium" data-id="element-107">
          Estás a un paso de la estrategia financiera que usan los millonarios
        </p>
      </div>

      {/* Call Info */}
      <motion.div initial={{
      opacity: 0,
      y: 15
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.2
    }} className="bg-primary rounded-xl p-3 text-white text-center shadow-lg" data-id="element-108">
        <div className="flex items-center justify-center gap-2" data-id="element-109">
          <Phone className="w-4 h-4" data-id="element-110" />
          <span className="text-sm font-bold" data-id="element-111">📞 Te Llamaremos Pronto</span>
        </div>
        <div className="flex items-center justify-center gap-1.5 mt-1.5 bg-white/20 rounded-lg py-1 px-2.5 inline-flex mx-auto" data-id="element-112">
          <Clock className="w-3 h-3" data-id="element-113" />
          <span className="font-semibold text-[11px]" data-id="element-114">
            ⏰ Próximas 2 Horas Hábiles
          </span>
        </div>
        <p className="mt-1.5 text-white/90 text-[11px]" data-id="element-115">
          Un asesor certificado te contactará para tu consulta de 30-45 min
        </p>
      </motion.div>

      {/* How the Call Will Be */}
      <motion.div initial={{
      opacity: 0,
      y: 15
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.3
    }} className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-116">
        <div className="px-3 py-2 border-b border-gray-200" data-id="element-117">
          <h2 className="text-xs sm:text-sm font-bold text-dark" data-id="element-118">
            📋 Cómo Será La Llamada
          </h2>
        </div>
        <div className="p-2.5 sm:p-3 space-y-2" data-id="element-119">
          <div className="flex items-start gap-3" data-id="element-120">
            <div className="flex-shrink-0 w-8 h-8 bg-amber-50 rounded-full flex items-center justify-center" data-id="element-121">
              <PhoneCall className="w-4 h-4 text-amber-600" data-id="element-122" />
            </div>
            <div data-id="element-123">
              <p className="font-bold text-dark text-xs flex items-center gap-1" data-id="element-124">
                <Zap className="w-3 h-3 text-amber-500" data-id="element-125" /> Número Puede Variar
              </p>
              <p className="text-gray-600 text-[11px] mt-0.5" data-id="element-126">
                El código de área puede cambiar según tu especialista asignado.
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3" data-id="element-127">
            <div className="flex-shrink-0 w-8 h-8 bg-blue-50 rounded-full flex items-center justify-center" data-id="element-128">
              <IdCard className="w-4 h-4 text-primary" data-id="element-129" />
            </div>
            <div data-id="element-130">
              <p className="font-bold text-dark text-xs flex items-center gap-1" data-id="element-131">
                <Zap className="w-3 h-3 text-amber-500" data-id="element-132" /> Identificación
                Completa
              </p>
              <p className="text-gray-600 text-[11px] mt-0.5" data-id="element-133">
                El asesor se presentará y confirmará tu solicitud.
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3" data-id="element-134">
            <div className="flex-shrink-0 w-8 h-8 bg-green-50 rounded-full flex items-center justify-center" data-id="element-135">
              <Volume2 className="w-4 h-4 text-green-600" data-id="element-136" />
            </div>
            <div data-id="element-137">
              <p className="font-bold text-dark text-xs flex items-center gap-1" data-id="element-138">
                <Zap className="w-3 h-3 text-amber-500" data-id="element-139" /> Ambiente Tranquilo
              </p>
              <p className="text-gray-600 text-[11px] mt-0.5" data-id="element-140">
                Busca un lugar privado. Consulta de 30-45 min.
              </p>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Info to Have Ready */}
      <motion.div initial={{
      opacity: 0,
      y: 15
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.4
    }} className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-141">
        <div className="px-3 py-2 border-b border-gray-200 bg-green-50" data-id="element-142">
          <h2 className="text-xs sm:text-sm font-bold text-dark" data-id="element-143">
            ✅ Ten Esta Info Lista
          </h2>
        </div>
        <div className="p-2.5 sm:p-3 grid grid-cols-2 gap-2" data-id="element-144">
          <div className="flex items-start gap-2" data-id="element-145">
            <div className="flex-shrink-0 w-6 h-6 bg-blue-50 rounded flex items-center justify-center" data-id="element-146">
              <User className="w-3.5 h-3.5 text-primary" data-id="element-147" />
            </div>
            <div data-id="element-148">
              <p className="font-bold text-dark text-xs" data-id="element-149">Datos Personales</p>
              <p className="text-gray-500 text-[10px]" data-id="element-150">
                Nacimiento, estado civil
              </p>
            </div>
          </div>
          <div className="flex items-start gap-2" data-id="element-151">
            <div className="flex-shrink-0 w-6 h-6 bg-red-50 rounded flex items-center justify-center" data-id="element-152">
              <Activity className="w-3.5 h-3.5 text-red-500" data-id="element-153" />
            </div>
            <div data-id="element-154">
              <p className="font-bold text-dark text-xs" data-id="element-155">Salud General</p>
              <p className="text-gray-500 text-[10px]" data-id="element-156">
                Altura, peso, historial
              </p>
            </div>
          </div>
          <div className="flex items-start gap-2" data-id="element-157">
            <div className="flex-shrink-0 w-6 h-6 bg-green-50 rounded flex items-center justify-center" data-id="element-158">
              <DollarSign className="w-3.5 h-3.5 text-green-600" data-id="element-159" />
            </div>
            <div data-id="element-160">
              <p className="font-bold text-dark text-xs" data-id="element-161">Ingresos</p>
              <p className="text-gray-500 text-[10px]" data-id="element-162">
                Anuales, metas 10-20 años
              </p>
            </div>
          </div>
          <div className="flex items-start gap-2" data-id="element-163">
            <div className="flex-shrink-0 w-6 h-6 bg-purple-50 rounded flex items-center justify-center" data-id="element-164">
              <Shield className="w-3.5 h-3.5 text-purple-600" data-id="element-165" />
            </div>
            <div data-id="element-166">
              <p className="font-bold text-dark text-xs" data-id="element-167">Protección</p>
              <p className="text-gray-500 text-[10px]" data-id="element-168">10-15x tu ingreso</p>
            </div>
          </div>
          <div className="flex items-start gap-2 col-span-2" data-id="element-169">
            <div className="flex-shrink-0 w-6 h-6 bg-amber-50 rounded flex items-center justify-center" data-id="element-170">
              <Users className="w-3.5 h-3.5 text-amber-600" data-id="element-171" />
            </div>
            <div data-id="element-172">
              <p className="font-bold text-dark text-xs" data-id="element-173">Beneficiarios</p>
              <p className="text-gray-500 text-[10px]" data-id="element-174">
                Nombres de quienes deseas proteger
              </p>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Trust Badges - Inline */}
      <motion.div initial={{
      opacity: 0,
      y: 15
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.45
    }} className="flex items-center justify-center gap-3 flex-wrap" data-id="element-175">
        <div className="flex items-center gap-1 bg-white rounded-full px-3 py-1.5 border border-gray-200 text-[11px] font-medium text-gray-700" data-id="element-176">
          <BadgeCheck className="w-3.5 h-3.5 text-green-600" data-id="element-177" /> Certificados
        </div>
        <div className="flex items-center gap-1 bg-white rounded-full px-3 py-1.5 border border-gray-200 text-[11px] font-medium text-gray-700" data-id="element-178">
          <ShieldCheck className="w-3.5 h-3.5 text-primary" data-id="element-179" /> Confidencial
        </div>
        <div className="flex items-center gap-1 bg-white rounded-full px-3 py-1.5 border border-gray-200 text-[11px] font-medium text-gray-700" data-id="element-180">
          <FileCheck className="w-3.5 h-3.5 text-purple-600" data-id="element-181" /> Sin Compromiso
        </div>
      </motion.div>

      {/* FAQ */}
      <motion.div initial={{
      opacity: 0,
      y: 15
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.5
    }} data-id="element-182">
        <h2 className="text-sm font-bold text-dark mb-2 flex items-center gap-1.5" data-id="element-183">
          <HelpCircle className="w-4 h-4 text-primary" data-id="element-184" /> Preguntas Rápidas
        </h2>
        <div className="space-y-1.5" data-id="element-185">
          <FAQItem question="¿Si no contesto la llamada?" answer="Intentaremos 2-3 veces en diferentes horarios." data-id="element-186" />
          <FAQItem question="¿Hay algún costo?" answer="No. La consulta es 100% gratuita y sin compromiso." data-id="element-187" />
          <FAQItem question="¿Necesito mucho dinero?" answer="No. Trabajamos desde $100 hasta $5,000+ mensuales." data-id="element-188" />
        </div>
      </motion.div>

      {/* Bottom CTA */}
      <motion.div initial={{
      opacity: 0,
      y: 15
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.55
    }} className="bg-primary rounded-xl p-3 text-center text-white shadow-lg" data-id="element-189">
        <p className="font-bold text-xs sm:text-sm mb-0.5" data-id="element-190">
          📱 Mantén tu teléfono cerca y con sonido activado
        </p>
        <p className="text-white/85 text-[11px]" data-id="element-191">
          Si ves una llamada en las próximas 2 horas, probablemente somos
          nosotros.
        </p>
      </motion.div>
    </div>;
}